/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import Ham from '../components/Ham';
import Nav from '../components/Nav';

function Header() {
    const [navbar, setHeader] = useState(false);

    const changeBackground = () => {
        //console.log(window.scrollY)
    }

    window.addEventListener('scroll', changeBackground);

    return (
        <div className="header active">
            <div className="logo">
                <Link exact to="/">
                    <img className="logowhite" src="./logo-white_One5Digital.png" alt="One5 Digital Agency Logo"/>
                    {/* <img className="logored" src="./logo-red_One5Digital.gif" alt="Loading..."/> */}
                </Link>
            </div>
            <ul className="nav-items">
                {/* <Ham /> */}
                <Nav />
            </ul>
        </div>
    )
}



export default Header